import React from 'react'
import CardSection from '../cardSection'

export default function MentorPool() {
    return (
        <>
            <CardSection role="mentorpool" section="05" sectionTitle="Mentors — A supportive force to enable success" />
        </>
    )
}
